module.exports = __webpack_public_path__ + "img/mgh-nagoya-sp.db67c222.jpg";